import React from "react";
import { ArrowRight, Phone, MapPin } from "lucide-react";
import { profile, stats } from "../data/mock";

const Hero = () => {
  return (
    <section id="top" className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 overflow-hidden bg-[#F8F5EE]">
      {/* Decorative backdrop \u2014 subtle gold radial */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[520px] h-[520px] rounded-full bg-[#C9A961]/10 blur-3xl" />
        <div className="absolute bottom-0 left-0 w-[420px] h-[420px] rounded-full bg-[#0B1E3F]/5 blur-3xl" />
        <div className="absolute inset-0 grain" />
      </div>

      <div className="max-w-7xl mx-auto container-px grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center relative z-10">
        {/* Left: text */}
        <div className="lg:col-span-7 order-2 lg:order-1">
          <span className="eyebrow">Healthcare Quality · Accreditation · Strategy</span>
          <h1 className="h-display text-4xl sm:text-5xl lg:text-7xl mt-6">
            Driving healthcare
            <br />
            excellence through
            <br />
            <span className="italic">quality management.</span>
          </h1>
          <p className="mt-8 max-w-xl text-[15px] lg:text-base leading-relaxed text-[#0B1E3F]/75">
            {profile.subheadline}
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <a href="#contact" className="btn-primary">
              Schedule a Consultation <ArrowRight size={16} />
            </a>
            <a href="#services" className="btn-ghost">
              Explore Services
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-6 text-[12px] tracking-[0.2em] uppercase text-[#0B1E3F]/60">
            <span className="flex items-center gap-2"><MapPin size={14} /> {profile.location}</span>
            <span className="flex items-center gap-2"><Phone size={14} /> {profile.contact.phone}</span>
          </div>
        </div>

        {/* Right: portrait card */}
        <div className="lg:col-span-5 order-1 lg:order-2">
          <div className="relative mx-auto max-w-md float-slow">
            <div className="absolute -top-6 -left-6 w-32 h-32 border-2 border-[#C9A961] hidden lg:block" />
            <div className="absolute -bottom-6 -right-6 w-40 h-40 bg-[#C9A961]/15 hidden lg:block" />
            <div className="relative bg-[#F8F5EE] p-3 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.5)]">
              <img
                src={profile.photo}
                alt={profile.name}
                className="w-full aspect-[4/5] object-cover object-top grayscale-0"
              />
              <div className="absolute -bottom-4 left-6 right-6 bg-[#0B1E3F] text-[#F8F5EE] px-5 py-3 flex items-center justify-between">
                <div>
                  <div className="font-serif text-lg leading-tight">{profile.name}</div>
                  <div className="text-[10px] tracking-[0.25em] uppercase text-[#C9A961]">Founder · DianaMik</div>
                </div>
                <div className="text-right">
                  <div className="font-serif text-2xl text-[#C9A961]">{profile.yearsActive}</div>
                  <div className="text-[9px] tracking-[0.2em] uppercase text-[#F8F5EE]/70">Years</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Stats bar */}
      <div className="max-w-7xl mx-auto container-px mt-24 lg:mt-28 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#0B1E3F]/10 border border-[#0B1E3F]/10">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#F8F5EE] p-6 lg:p-8 reveal">
              <div className="font-serif text-4xl lg:text-5xl text-[#0B1E3F]">
                {s.value}
              </div>
              <div className="mt-2 text-[11px] tracking-[0.2em] uppercase text-[#0B1E3F]/60">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
